import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import LoginPage from './Components/Login/Login';
import HowItWorks from './pages/HowItWorks';
import About from './pages/About';
import Awards from './pages/Awards';
import Modal from './Components/Modals/PartnershipModal.js';
import Solutions from './pages/Solution';
import Contact from './pages/Contact';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsAndConditions from './pages/TermsCondition'
import FAQS from './pages/FAQS.js'

import './App.css';

function App() {
  const location = useLocation();

  const hideHeaderRoutes = ['/login'];

  const shouldHideheader = hideHeaderRoutes.includes(location.pathname);
  return (
    <>
      {!shouldHideheader && <Header />}

      <Routes>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/solutions' element={<Solutions />} />
        <Route path='/how-it-works' element={<HowItWorks />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/faqs' element={<FAQS />} />
        {/* <Route path='/awards' element={<Awards />} /> */}
        {/* <Route path='/case-studies' element={<CaseStudies />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path='/terms-conditions' element={<TermsAndConditions />} />
      </Routes>

      {!shouldHideheader && <Footer />}
    </>
  );
}

export default function AppwithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
};